/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderConfigurationCreateDTO } from '../models/OrderConfigurationCreateDTO';
import type { OrderDTO } from '../models/OrderDTO';
import type { OrderDTOODataListResponse } from '../models/OrderDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrderService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns OrderDTOODataListResponse Success
     * @throws ApiError
     */
    public static getOrder(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<OrderDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Order',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static postOrder(
requestBody?: OrderDTO,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Order',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteOrder(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/Order',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static getOrder1(
key: number,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Order/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static putOrder(
key: number,
requestBody?: OrderDTO,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/Order/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static putOrderPlace(
key: number,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/Order/{key}/place',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postOrderCreate(
requestBody?: OrderConfigurationCreateDTO,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Order/create',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
